// extracted by mini-css-extract-plugin
export var footer = "_n1-0";
export var inherit = "_n1-1";
export var input = "_n1-2";
export var modalContent = "_n1-3";
export var quillEditor = "_n1-4";
export var subtitle = "_n1-5";